import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../Admin/Sidebar';
import NotificationBell from './NotificationBell';
import MobileLogo from './MobileLogo';
import PageTransition from './PageTransition';
import '../../styles/Admin.css';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Close sidebar on navigation (mobile)
  useEffect(() => { setSidebarOpen(false); }, [location]);

  return (
    <div className="admin-container">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="main-content">
        <NotificationBell />
        {/* Mobile top bar */}
        <div className="mobile-topbar">
          <button className="hamburger-btn" onClick={() => setSidebarOpen(o => !o)}>
            <span /><span /><span />
          </button>
          <MobileLogo />
          <NotificationBell variant="inline" />
        </div>
        <div className="page-content">
          <PageTransition><Outlet /></PageTransition>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
